export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-574_tn.ce409884.jpg";